import { useQContent } from '@exam-management/common/qcontent-provider';
import { Flex, ReadonlyField } from '@shared/components';

export default function OwnerView() {
  const { qContent } = useQContent();

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <ReadonlyField
        label='ผู้พัฒนาข้อสอบ'
        content={qContent.metadata.owner?.value ?? 'ไม่ได้ระบุ'}
      />
      <ReadonlyField label='ผู้ทบทวนข้อสอบ 1' content={qContent.metadata.audit1 ?? 'ไม่ได้ระบุ'} />
      <ReadonlyField label='ผู้ทบทวนข้อสอบ 2' content={qContent.metadata.audit2 ?? 'ไม่ได้ระบุ'} />
      <ReadonlyField label='ผู้ทบทวนข้อสอบ 3' content={qContent.metadata.audit3 ?? 'ไม่ได้ระบุ'} />
    </Flex>
  );
}
